import { render, staticRenderFns } from "./etc.plateNoBoard.vue?vue&type=template&id=0b941c0a&scoped=true"
import script from "./etc.plateNoBoard.vue?vue&type=script&lang=js"
export * from "./etc.plateNoBoard.vue?vue&type=script&lang=js"
import style0 from "./etc.plateNoBoard.vue?vue&type=style&index=0&id=0b941c0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b941c0a",
  null
  
)

export default component.exports